(ns app.survey.login.view
  (:require
   [ui.util :as uu]
   [app.survey.login.email-or-sms.view :as email-or-sms-view]
   [app.survey.login.email.view :as email-view]
   [app.survey.login.no-process.view :as no-process-view]
   [app.survey.login.sms.view :as sms-view]
   [app.survey.sub :as survey-sub]
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.utils :as fu]
   [re-frame.core :as rf]
   [ui.components.alert-list.view :as alert-list]))


(defn login-form
  [tenant template auth-type]
  (let [template-logo (:survey-template/login-image template)
        logo (cond (not (cu/blank-value? template-logo))
                   template-logo
                   (not (cu/blank-value? (:tenant/survey-logo tenant)))
                   (:tenant/survey-logo tenant)
                   (not (cu/blank-value? (:tenant/logo tenant)))
                   (:tenant/logo tenant))]
    [:div
     {:class (uu/cm "w-full h-full md:w-[400px] py-6 px-4 flex flex-col bg-complement-light overflow-y-auto")}
     [:div
      {:class (uu/cm "flex flex-col shrink-0 grow-0")}
      (if logo
        [:img
         {:class "w-28 mx-auto"
          :src   (fu/sanitize-img-url logo)}]
        [:h1 (:tenant/name tenant)])]

     [:div
      {:class (uu/cm "py-10 px-4 flex flex-col shrink-0 grow-0")}
      (case auth-type
        :auth-type/email-or-sms
        [email-or-sms-view/view]
        :auth-type/email
        [email-view/view]
        :auth-type/sms
        [sms-view/view]
        nil
        [no-process-view/view]
        (loc/tr :unknown-auth-type [auth-type]))]
     [:div
      {:class (fu/cs "flex flex-col flex-auto align-items-center justify-items-end justify-content-end")}
      [:span
       {:class-name "block pb-1 text-xxs text-complement-light-text"}
       "powered by"]
      [:img
       {:class "max-w-[80px]"
        :src   "https://static.zapflow.com/app/img/Zapflow_logo_black.svg"}]]]))


(defn view
  []
  (let [auth-type @(rf/subscribe [::survey-sub/auth-type])
        tenant @(rf/subscribe [::survey-sub/tenant])
        banner-image (:tenant/survey-banner-image tenant)
        template @(rf/subscribe [::survey-sub/survey-template])]
    (js/console.log "Survey login " auth-type)
    [:div
     {:class "w-full h-full flex justify-stretch items-stretch"}
     [:div
      {:class "flex flex-1"}
      [:div
       {:class-name "relative"}
       [:div
        {:class-name "lg:w-[540px] fixed left-2/4 -translate-x-2/4 top-4"}
        [alert-list/view :login-notifications]]
       [login-form tenant template auth-type]]
      [:div
       {:class "flex flex-1 flex-col"}
       [:div
        {:class (uu/cm "w-full h-full bg-repeat bg-center bg-cover")
         :style (if banner-image
                  {:background-image (str "url(" banner-image ")")}
                  {})}]]]]))
